import { useState, useCallback } from 'react';
import { getCSRFToken } from '../utils/csrf';
import type { ProfileUser, ApiResponseWithUser } from '../types/profile';

export function useProfileApi(updateUrl: string) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const updateProfile = useCallback(async (
        data: Partial<ProfileUser>
    ): Promise<ApiResponseWithUser> => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await fetch(updateUrl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-XSRF-TOKEN': getCSRFToken(),
                },
                body: JSON.stringify(data),
            });

            const result = await response.json();

            if (!response.ok) {
                setError(result.message || 'Error al actualizar');
            }

            return result;
        } catch (err) {
            const message = err instanceof Error ? err.message : 'Error de conexión';
            setError(message);
            return { success: false, message };
        } finally {
            setIsLoading(false);
        }
    }, [updateUrl]);

    return { updateProfile, isLoading, error };
}
